<template>
  <span
    v-if="active"
    class="rec-filter-eraser"
    role="button"
    tabindex="0"
    :title="title"
    @click.stop="$emit('clear')"
    @keydown.enter.stop="$emit('clear')"
  >
    <b-icon icon="eraser" font-scale="1"></b-icon>
  </span>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

// Eraser icon for the Reconciliation page's top filters and table headers. Purely presentational:
// the parent decides what counts as active and what clearing does. Shown only while there's
// something to clear, same as BDXValidationReport's own per-filter clear icons.
export default defineComponent({
  name: 'rec-filter-eraser',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Clear filter'
    }
  },
  emits: ['clear']
})
</script>

<style lang="scss" scoped>
// Same look as BDXValidationReport.scss's .bdx-filter-clear-icon, so both reports match. The fixed
// font-size gives the icon its own visible size regardless of the small label text next to it.
.rec-filter-eraser {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #8a8272;
  flex-shrink: 0;
  font-size: 0.9rem;

  &:hover {
    color: #b06a1e;
  }
}
</style>
